import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Partners\EnaosController::sendFicheDecesToEnaos
* @see app/Http/Controllers/Partners/EnaosController.php
* @route '/api/send-dossier-enaos/{dossier}'
*/
export const sendFicheDecesToEnaos = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: sendFicheDecesToEnaos.url(args, options),
    method: 'post',
})

sendFicheDecesToEnaos.definition = {
    methods: ["post"],
    url: '/api/send-dossier-enaos/{dossier}',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Partners\EnaosController::sendFicheDecesToEnaos
* @see app/Http/Controllers/Partners/EnaosController.php
* @route '/api/send-dossier-enaos/{dossier}'
*/
sendFicheDecesToEnaos.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return sendFicheDecesToEnaos.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Partners\EnaosController::sendFicheDecesToEnaos
* @see app/Http/Controllers/Partners/EnaosController.php
* @route '/api/send-dossier-enaos/{dossier}'
*/
sendFicheDecesToEnaos.post = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: sendFicheDecesToEnaos.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Partners\EnaosController::getTicket
* @see app/Http/Controllers/Partners/EnaosController.php
* @route '/api/fetch-ticket-enaos'
*/
export const getTicket = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: getTicket.url(options),
    method: 'get',
})

getTicket.definition = {
    methods: ["get","head"],
    url: '/api/fetch-ticket-enaos',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Partners\EnaosController::getTicket
* @see app/Http/Controllers/Partners/EnaosController.php
* @route '/api/fetch-ticket-enaos'
*/
getTicket.url = (options?: RouteQueryOptions) => {
    return getTicket.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Partners\EnaosController::getTicket
* @see app/Http/Controllers/Partners/EnaosController.php
* @route '/api/fetch-ticket-enaos'
*/
getTicket.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: getTicket.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Partners\EnaosController::getTicket
* @see app/Http/Controllers/Partners/EnaosController.php
* @route '/api/fetch-ticket-enaos'
*/
getTicket.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: getTicket.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Partners\EnaosController::sendAttachment
* @see app/Http/Controllers/Partners/EnaosController.php
* @route '/api/send-attachment-enaos/{dossier}'
*/
export const sendAttachment = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: sendAttachment.url(args, options),
    method: 'post',
})

sendAttachment.definition = {
    methods: ["post"],
    url: '/api/send-attachment-enaos/{dossier}',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Partners\EnaosController::sendAttachment
* @see app/Http/Controllers/Partners/EnaosController.php
* @route '/api/send-attachment-enaos/{dossier}'
*/
sendAttachment.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return sendAttachment.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Partners\EnaosController::sendAttachment
* @see app/Http/Controllers/Partners/EnaosController.php
* @route '/api/send-attachment-enaos/{dossier}'
*/
sendAttachment.post = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: sendAttachment.url(args, options),
    method: 'post',
})

const EnaosController = { sendFicheDecesToEnaos, getTicket, sendAttachment }

export default EnaosController